import { Box, Input, Link } from '@chakra-ui/react';
import { saveTest } from './utils';
import { transformRSInput } from '../../formControllers/Transformation/Utils';
import React from 'react';


const InfoLink = ({ props,qObj,value }) => {
  const jobSeekerData = props.formikProps.values ? props.formikProps.values.jobSeekerData : {};
  const index = props.stateProps.sectionData.sectionIndex;
  return(
  <Box display='flex' justifyContent='space-between'  paddingLeft="8px" marginLeft="1.8rem" marginTop=".6rem" width='90%'>
    <Box paddingTop='.5rem' fontWeight='bold' width='40%'>{qObj.question}</Box>
     <Box width='50%'>
      <Input
        id={qObj.qid}
        onBlur={e=> {
          saveTest(e,props);
        }}
        placeholder={qObj.placeholder}
        value = {value}
        onChange={e =>
          transformRSInput(e, jobSeekerData, index, qObj, props)
        }
        sx={{ paddingRight: 0, margin: 0 }}
      /></Box>

  </Box>
  )
};

export default InfoLink;